import { Component, EventEmitter, Input, OnInit, Output, OnDestroy, HostListener } from '@angular/core';
import { PeerData } from 'src/app/models/PeerData';
import { Voter } from 'src/app/models/Voter';

@Component({
  selector: 'app-roles-table',
  templateUrl: 'roles-table.component.html',
  styleUrls: ['./roles-table.component.less', '../../shared/common.less'],
})

export class RolesTableComponent implements OnInit, OnDestroy {
  @Input() suspended: Array<any> = [];
  @Input() selectedVoters: any;
  @Input() filteredVoters: Array<Voter> = [];
  @Input() editionMode: boolean = true;
  @Output() selectedVotersChange = new EventEmitter<any>();
  @Output() voterEdited = new EventEmitter<void>();
  @Output() profileChangeRequested = new EventEmitter<string>();
  @Output() invitationResendRequested = new EventEmitter<string>();
  @Output() deactivationRequested = new EventEmitter<{ email: string; activate: boolean }>();
  @Output() profileRemovalRequested = new EventEmitter<PeerData>();
  editingIndex: number = -1;
  editingVoter: Partial<Voter> = {};
  openMenuIndex: number = -1;
  menuPosition: { top: number; left: number } = { top: 0, left: 0 };
  private intervalId: any;

  constructor() { }

  selectionChangedEvent(newSelection: any) {
    console.log('Ligne sélectionnée:', newSelection);
    this.selectedVoters = newSelection;
    this.selectedVotersChange.emit(newSelection);
  }

  editLastNameAtIndex(index: number, value: string) {
    this.editingVoter = { ...this.editingVoter, lastName: value };
  }

  editFirstNameAtIndex(index: number, value: string) {
    this.editingVoter = { ...this.editingVoter, firstName: value };
  }

  editCollegeAtIndex(index: number, value: string) {
    this.editingVoter = { ...this.editingVoter, college: value };
  }

  editEmailAtIndex(index: number, value: string) {
    this.editingVoter = { ...this.editingVoter, email: value };
  }

  editPhoneAtIndex(index: number, value: string) {
    this.editingVoter = { ...this.editingVoter, phone: value };
  }

  editValidationCodeAtIndex(index: number, value: string) {
    this.editingVoter = { ...this.editingVoter, validationCode: value };
  }

  resetVoters() {
    this.filteredVoters = [];
  }

  toggleMenu(index: number, event: Event) {
    event.stopPropagation();
    if (this.openMenuIndex === index) {
      this.openMenuIndex = -1;
      return;
    }
    const btn = event.target as HTMLElement;
    const rect = btn.getBoundingClientRect();
    this.menuPosition = { top: rect.bottom + 4, left: rect.right - 150 };
    this.openMenuIndex = index;
  }

  changeProfile(voter: any) {
    this.openMenuIndex = -1;
    this.profileChangeRequested.emit(voter.email);
  }

  resendInvitation(voter: any) {
    this.openMenuIndex = -1;
    this.invitationResendRequested.emit(voter.email);
  }

  deactivate(voter: any) {
    this.openMenuIndex = -1;
    this.deactivationRequested.emit({ email: voter.email, activate: false });
  }

  activate(voter: any) {
    this.openMenuIndex = -1;
    this.deactivationRequested.emit({ email: voter.email, activate: true });
  }

  removeProfile(voter: PeerData) {
    this.openMenuIndex = -1;
    this.profileRemovalRequested.emit(voter);
  }

  defineRole(profile: number): string {
    switch (profile) {
      case 0:
        return "RH";
      case 1:
        return "BV";
      case 2:
        return "SC";
      case 3:
        return "CP";
      default:
        return "";
    }
  }

  getRoleBackgroundColor(profile: number): string {
    switch (profile) {
      case 0:
        return "#D8E8FF";
      case 1:
        return "#CBFFD5";
      case 2:
        return "#E8EDF3";
      case 3:
        return "#FDE7F3";
      default:
        return "#FFFFFF";
    }
  }

  getRemainingTime(voter: any): string {
    const lockDate = new Date(voter.lockDate);
    const now = new Date();
    
    // Ajouter 1 minute à la date de blocage pour obtenir la date de déblocage
    const unlockDate = new Date(lockDate.getTime() + 60 * 1000); // +60 secondes
    
    // Calculer le temps restant en millisecondes
    const remainingMilliseconds = unlockDate.getTime() - now.getTime();
    
    // Si le temps est écoulé, retourner 00:00
    if (remainingMilliseconds <= 0) {
      return '00:00';
    }
    
    // Convertir en secondes totales
    const remainingSeconds = Math.floor(remainingMilliseconds / 1000);
    
    // Calculer les minutes et secondes
    const minutes = Math.floor(remainingSeconds / 60);
    const seconds = remainingSeconds % 60;
    
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  ngOnInit(): void {
    // Mettre à jour le décompte toutes les secondes
    this.intervalId = setInterval(() => {
      // Force Angular à détecter les changements
    }, 1000);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    // Fermer le menu si on clique ailleurs
    this.openMenuIndex = -1;
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}
